import { render, staticRenderFns } from "./TaskNotification.vue?vue&type=template&id=c6d3385e&scoped=true&lang=pug"
import script from "./TaskNotification.vue?vue&type=script&lang=js"
export * from "./TaskNotification.vue?vue&type=script&lang=js"
import style0 from "./TaskNotification.vue?vue&type=style&index=0&id=c6d3385e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d3385e",
  null
  
)

export default component.exports